module.exports = __webpack_public_path__ + "img/quick-chat.0b4b0821.svg";